import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as api from "./api";

export default function useExerciseTemplateList() {
    const navigate = useNavigate();
    const [templates, setTemplates] = useState([]);
    const [levels, setLevels] = useState([]);
    const [classifications, setClassifications] = useState([]);
    const [search, setSearch] = useState("");
    const [levelFilter, setLevelFilter] = useState("");
    const [classificationFilter, setClassificationFilter] = useState("");
    const [refresh, setRefresh] = useState(0);
    const [createOpen, setCreateOpen] = useState(false);

    useEffect(() => {
        api.getExerciseTemplates()
            .then((response) => setTemplates(Array.isArray(response.data) ? response.data : []))
            .catch((err) => {
                if (err.response && err.response.status === 401) navigate("/login");
            });
    }, [refresh, navigate]);

    useEffect(() => {
        api.getLevels().then((response) => setLevels(Array.isArray(response.data) ? response.data : [])).catch(() => {});
        api.getExerciseClassifications().then((response) => setClassifications(Array.isArray(response.data) ? response.data : [])).catch(() => {});
    }, []);

    const visibleTemplates = useMemo(() => {
        const query = search.trim().toLowerCase();
        const newestFirst = [...templates].sort((a, b) => b.id - a.id);
        return newestFirst.filter((t) => {
            if (levelFilter && (!t.level || String(t.level.id) !== String(levelFilter))) return false;
            if (classificationFilter && (!t.classification || String(t.classification.id) !== String(classificationFilter))) return false;
            if (!query) return true;
            const haystack = ((t.name || "") + " " + (t.description || "")).toLowerCase();
            return haystack.includes(query);
        });
    }, [templates, search, levelFilter, classificationFilter]);

    const refreshList = () => setRefresh((prev) => prev + 1);
    const openCreate = () => setCreateOpen(true);
    const closeCreate = () => setCreateOpen(false);

    const onCreated = (createdTemplate) => {
        closeCreate();
        if (createdTemplate && createdTemplate.id) {
            navigate("/exercise-templates/" + createdTemplate.id);
        } else {
            refreshList();
        }
    };

    return {
        templates: visibleTemplates,
        totalCount: templates.length,
        levels,
        classifications,
        search,
        setSearch,
        levelFilter,
        setLevelFilter,
        classificationFilter,
        setClassificationFilter,
        createOpen,
        openCreate,
        closeCreate,
        onCreated,
        refreshList,
    };
}
